import { useParams } from "react-router-dom";
import ContentHeader from "../../widgets/contentHeader/ContentHeader";
import { DateFilter } from "../../widgets/weatherStationReview/DateFilter";

export function WeatherStationReviewPage() {
    const { stationId } = useParams();
    return (
        <>
            <ContentHeader title="Метеостанция" />
            <div className="weather-station-review-page-div">
                <DateFilter />
            </div>
        </>
    )
}
